import Modal, { ModalStateProps } from '../../../ui/Modal'
import './ImageGalleryModal.css'
import { Font, Resource } from '../../../types'
import { useTranslation } from 'react-i18next'
import FormWrapper from '../../../ui/form/FormWrapper'
import TextInput from '../../../ui/form/TextInput'
import { MultiSelect } from '../../../ui/form/MultiSelect'
import api from '../../../api'
import { useContext } from 'react'
import { ProjectContext } from '../../../contexts'
import { fontWeightOptions } from './fonts'

interface ResourceModalProps extends ModalStateProps {
    resource?: Resource
    onInsert?: (resource: Resource) => void
}

export default function ResourceFontModal({ open, onClose, resource, onInsert }: ResourceModalProps) {
    const { t } = useTranslation()
    const [project] = useContext(ProjectContext)

    const handleSaveFont = async (params: Font) => {
        const value = {
            name: params.name,
            value: params.value,
            url: params.url,
            weights: params.weights ?? [],
        }
        const saved = resource
            ? await api.resources.update(project.id, resource.id, { name: params.name, value })
            : await api.resources.create(project.id, { type: 'font', name: params.name, value })
        onInsert?.(saved)
    }

    return (
        <Modal
            title={resource ? t('edit_font') : t('add_font')}
            open={open}
            onClose={onClose}
            size="small">
            <FormWrapper<Font>
                onSubmit={async (params) => { await handleSaveFont(params) }}
                defaultValues={resource?.value as Font}
                submitLabel={resource ? t('save') : t('create')}>
                {form => <>
                    <TextInput.Field
                        form={form}
                        name="name"
                        label={t('name')}
                        required />
                    <TextInput.Field
                        form={form}
                        name="value"
                        label={t('font_family')}
                        required />
                    <TextInput.Field
                        form={form}
                        name="url"
                        label={t('url')}
                        subtitle={t('font_url_desc')}
                        required />
                    <MultiSelect.Field
                        form={form}
                        name="weights"
                        label={t('font_weights')}
                        subtitle={t('font_weights_desc')}
                        options={fontWeightOptions(t)}
                        toValue={(option) => option.key}
                        getOptionDisplay={(option) => option.label}
                    />
                </>}
            </FormWrapper>
        </Modal>
    )
}
